"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlacesSearchFactory = void 0;
const NearbySearch_1 = require("../search/NearbySearch");
const TextSearch_1 = require("../search/TextSearch");
const FindByTextSearch_1 = require("../search/FindByTextSearch");
const PlaceDetailsSearch_1 = require("../search/PlaceDetailsSearch");
const AutoCompleteSearch_1 = require("../search/AutoCompleteSearch");
const QueryAutoCompleteSearch_1 = require("../search/QueryAutoCompleteSearch");
class PlacesSearchFactory {
    nearbysearch() {
        return new NearbySearch_1.NearbySearch();
    }
    findbytextsearch() {
        return new FindByTextSearch_1.FindByTextSearch();
    }
    textsearch() {
        return new TextSearch_1.TextSearch();
    }
    detailsearch() {
        return new PlaceDetailsSearch_1.PlaceDetailsSearch();
    }
    autocomplete() {
        return new AutoCompleteSearch_1.AutoCompleteSearch();
    }
    queryautocomplete() {
        return new QueryAutoCompleteSearch_1.QueryAutoCompleteSearch();
    }
}
exports.PlacesSearchFactory = PlacesSearchFactory;
//# sourceMappingURL=PlacesSearchFactory.js.map